// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"88":"cb696f362b46f294","630":"9987f8009a3bd61c","639":"9ed0a337bc845d49","784":"700647433dd4d1db","793":"42ef63b7ec463244","955":"9a9d59006bc9ce05"}[chunkId] + ".js";
};